import * as React from "react";
import { Font, StyleSheet, Document } from "@react-pdf/renderer";
import Report6PDFTemplateApplicant from "./Report6PDFTemplateApplicant";
import { TReport6ApplicantPresentationModel } from "../../../presenter/report/model/Report6ApplicantPresentationModel";
import SagoeUi from "../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiItalic from "../../assets/fonts/a1f05a6515e69ab2886bdaaf1489d410.ttf";
import SagoeUiBold from "../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

const Report6PDFTemplate = ({
  translate,
  applicants,
  title,
  subtitle
}: {
  translate: any;
  applicants: TReport6ApplicantPresentationModel[];
  title: string;
  subtitle?: string;
}) => {
  const renderApplicants = () => {
    let renderedApplicants: JSX.Element[] = [];
    applicants.forEach((applicant: TReport6ApplicantPresentationModel) => {
      renderedApplicants.push(
        <Report6PDFTemplateApplicant
          key={`pdf-applicant-${applicant.id}`}
          translate={translate}
          applicant={applicant}
          styles={styles}
        />
      );
    });
    return renderedApplicants;
  };
  return <Document title={title}>{renderApplicants()}</Document>;
};

export default Report6PDFTemplate;

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    {
      src: SagoeUiItalic,
      fontStyle: "italic"
    },
    { src: SagoeUi }
  ]
});

const styles = StyleSheet.create({
  body: {
    padding: 20
  },
  titleCol: {
    display: "flex",
    flexDirection: "column"
  },
  title: {
    fontSize: 14,
    marginTop: 10,
    marginBottom: 5,
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 10,
    fontFamily: "Segoe UI"
  },
  regularText: {
    fontSize: 10,
    fontFamily: "Segoe UI"
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  subTable: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 0
  },
  tableCol: {
    width: "11%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 1
  },
  subTableCol: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginLeft: 5,
    marginRight: 5,
    fontSize: 10,
    fontFamily: "Segoe UI"
  },
  previewTable: {
    display: "flex",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column"
  },
  previewRow: {
    margin: "auto",
    flexDirection: "row",
    width: "100%",
    display: "flex"
  },
  pageNumbers: {
    fontSize: 10,
    fontFamily: "Segoe UI",
    position: "absolute",
    bottom: "30pt",
    right: "37pt"
  }
});
